import styled, { css } from 'styled-components';

type BadgeProps = {
    $isCurrent: boolean;
    available: boolean;
};

export const CardShopWrapper = styled.div`
    width: 100%;
    border-radius: 0.75rem;
    padding: 0.75rem;
    gap: 1rem;
    display: flex;
    align-items: center;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
    align-self: stretch;

    @media (max-width: 768px) {
        gap: 0.75rem;
    }
`;

export const VideoScreen = styled.img`
    width: 7.375rem;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: 6px;
    @media (max-width: 768px) {
        display: none;
    }
`;

export const DetailsShopWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1;

    h3 {
        font-size: 1.25rem;
        line-height: 1rem;
        font-weight: 800;
        margin: 0;
    }

    span {
        font-size: 0.875rem;
        line-height: 1rem;
        font-weight: 500;
    }

    section {
        color: ${({ theme }) => theme.colors['neutral-500']};
        display: flex;
        align-items: center;
        justify-content: start;

        gap: 0.2rem;
    }

    span.description {
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        overflow: hidden;
    }
`;

export const BadgeWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    gap: 0.75rem;
    flex-wrap: wrap;

    width: 100%;
`;

export const BadgeHour = styled.div<BadgeProps>`
    position: relative;
    outline: solid 2px
        ${({ theme, $isCurrent }) => {
            return $isCurrent
                ? theme.colors['supernova-500']
                : theme.colors['silver-100'];
        }};
    border-radius: 0.75rem;
    display: flex;
    padding: 0.5rem 0.75rem;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    overflow: hidden;

    cursor: ${(props) => props.available ? "pointer" : "not-allowed"};

    background-color: ${({ theme, $isCurrent }) => {
        return $isCurrent ? theme.colors['supernova-100'] : 'transparent';
    }};
    ${(props) => !props.available ? css`
        background-color: ${({ theme }) => theme.colors['neutral-100']};
        outline: solid 2px ${({ theme }) => theme.colors['neutral-200']};
        color: ${({ theme }) => theme.colors['neutral-400']};

        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 120%;
            height: 120%;
            opacity: 0.5;
            border-top: 4px solid ${({ theme }) => theme.colors['neutral-400']};
            transform: rotate(22deg);
            transform-origin: top left;
            pointer-events: none;
        }
    ` : ""}

    span {
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1rem;
    }

    .tippy-box {
        border-radius: 0.5rem;
        outline: 1px solid blue;
        background: red;

        box-shadow: 0px 0px 20px 10px black;
        /* background: rgba(50, 50, 50, 0.5); */
        backdrop-filter: blur(15px);
    }
`;

export const ButtonShop = styled.button`
    background-color: ${({ theme }) => theme.colors['silver-100']};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    border-radius: 0.5rem;
    border: transparent;

    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;

    &.blue {
        gap: .5rem;
        background: #008cff;
        color: #fff;
        padding: 0.5rem 1rem;
        color: var(--Neutral-0, #fff);
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.2rem;

        svg {
            color: #fff !important;

            path {
                stroke: #fff !important;
            }
        }
    }
`;

export const HoursElementsText = styled.span`
    color: ${({ theme }) => theme.colors['neutral-500']};

    font-size: 0.75rem;
    font-weight: 500;
`;


export const UnavailableTippyContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 0.75rem;
    background-color: rgba(18, 18, 18, 0.8);
    border-radius: 6px;

    span {
        color: white;
        font-weight: 500;
        font-size: 1rem;
        line-height: 1rem;
    }
`

export const AllSchedulesUnavailable = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.4rem;
    gap: 0.2rem;
    color: ${({ theme }) => theme.colors['neutral-500']};

    span {
        font-weight: 500;
        font-size: 0.9rem;
    }
`